import React from "react";

function useAsyncRequest(request, success, error) {
    return async () => {
        try {
            const response = await request();
            const {status, message} = response.data

            if (status === 'success') {
                success(response.data);
            }
        } catch (e) {
            error(e);
        }
    };
}

export default useAsyncRequest;